export const ADD_TO_BASKET = 'plp.addToBasket';
export const ALSO_SEARCHED = 'plp.alsoSearched';
export const ALTERNATE_IMAGE = 'plp.imageAlternate';
export const ANALYTICS_SEPARATOR = '|';
export const CHUNK_LOADED = 'plp.chunkLoad';
export const COLOUR_SELECTED = 'plp.colourSelected';
export const COMPARE_PRODUCTS = 'plp.compareClicked';
export const FILTER_APPLIED = 'plp.filterApplied';
export const FILTER_INTERACTION = 'plp.filterInteraction';
export const FILTER_REMOVED = 'plp.filterRemoved';
export const GLOBAL_INTERACTION = 'global.interaction';
export const GLOBAL_SEARCH_INTERACTION = 'global.searchInteraction';
export const MANAGED_IMPRESSION = 'managedImpression';
export const PAGE_LOAD = 'pageload';
export const PAGINATION = 'plp.changePageNum';
export const PRODUCT_CARD_TOGGLE_CHANGED = 'plp.productCardToggle';
export const SORT_OPTION_CHANGED = 'plp.changeSortOption';
export const CITRUS_AD_CLICK = 'citrusAd.clicked';
export const ANALYTICS_JLDATA_UPDATED = 'JlDataUpdateComplete';
export const COMPARE_DATA_UPDATED = 'compareDataUpdateComplete';
export const FOUNDIT_CLICK = 'foundit.clicked';
